import { Asset } from "../generated/gql/graphql";

/**
 * Formats a Date object into 'YYYY-MM-DD' string format.
 *
 * @param {Date} date - The date to format.
 * @returns {string} The formatted date string.
 */
export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function getLatestDate(target: Asset): Date {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const updatedDate = new Date(target.dateUpdated);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const createdDate = new Date(target.dateCreated);

  if (createdDate.getTime() > updatedDate.getTime()) {
    return createdDate;
  }

  return updatedDate;
}
